import React, { useState, useEffect } from 'react';
import contentfulClient from '../contentfulClient';

const BLOG_POST_CONTENT_TYPE_ID = 'blogPost'; 

function BlogList() {
  const [featuredPost, setFeaturedPost] = useState(null);
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const mapPostItem = (item) => {
    const fields = item.fields || {};
    
    if (!fields.title || !fields.slug || !fields.publishDate || !fields.excerpt) {
        console.warn("Skipping post due to missing required fields:", item.sys.id);
        return null; 
    }
    
    const publishDate = new Date(fields.publishDate);
    const now = new Date();

    if (publishDate > now) {
        return null; 
    }

    return {
      id: item.sys.id,
      title: fields.title,
      slug: fields.slug,
      excerpt: fields.excerpt, 
      publishDate: fields.publishDate,
      isFeatured: fields.isFeatured || false,
      imageUrl: fields.featuredImage 
        ? `https:${fields.featuredImage.fields.file.url}`
        : null, 
    };
  };

  useEffect(() => {
    const fetchBlogPosts = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const response = await contentfulClient.getEntries({
          content_type: BLOG_POST_CONTENT_TYPE_ID,
          order: '-fields.publishDate', 
        });
        const allPosts = response.items.map(mapPostItem).filter(post => post !== null);
        const foundFeaturedPost = allPosts.find(post => post.isFeatured);
        const regularPosts = allPosts.filter(post => !post.isFeatured);

        setFeaturedPost(foundFeaturedPost || null);
        setBlogPosts(regularPosts);

      } catch (err) {
        console.error("Contentful Fetch Error on BlogList:", err);
        setError("Failed to load blog posts. Check Contentful connection and Content Model ID.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  if (isLoading) {
    return <div className="container mt-5 text-center">Loading Blog Posts...</div>;
  }

  if (error) {
    return <div className="container mt-5 text-danger text-center">Error: {error}</div>;
  }
  
  if (blogPosts.length === 0 && !featuredPost) {
    return <div className="container mt-5 text-center">No published blog posts found.</div>;
  }

  return (
    <div id="blog-page" className="container my-5 pt-5">
      {featuredPost && (
        <div
          className="p-4 p-md-5 mb-4 text-white rounded" 
          style={{ 
            backgroundImage: featuredPost.imageUrl ? `url(${featuredPost.imageUrl})` : 'none',
            backgroundColor: featuredPost.imageUrl ? 'rgba(0, 0, 0, 0.5)' : '#343a40',
            backgroundBlendMode: 'multiply',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: 'pointer',
          }}
          onClick={() => window.location.href = `/blog/${featuredPost.slug}`}
        >
          <div className="col-md-8 px-0">
            <h1 className="display-4 fst-italic">{featuredPost.title}</h1>
            <p className="lead my-3">{featuredPost.excerpt}</p>
            <p className="lead mb-0">
              <a href={`/blog/${featuredPost.slug}`} className="text-white fw-bold">
                Continue reading...
              </a>
            </p>
          </div>
        </div>
      )}
      
      {blogPosts.length > 0 && (
          <>
            {featuredPost && <h2 className="mb-4">Latest Posts</h2>}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {blogPosts.map((post) => (
                <div className="col" key={post.id}>
                  <a 
                    href={`/blog/${post.slug}`} 
                    className="text-decoration-none text-dark d-block h-100"
                  >
                    <div className="card h-100 shadow-sm transition-shadow hover-shadow-lg">
                      {post.imageUrl ? (
                        <img src={post.imageUrl} className="card-img-top" alt={post.title} style={{ height: '180px', objectFit: 'cover' }}/>
                      ) : (
                        <div style={{ height: '180px', backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No Image</div>
                      )}
                      <div className="card-body">
                        <h5 className="card-title text-dark">{post.title}</h5> 
                        <h6 className="card-subtitle mb-2 text-muted">
                          {new Date(post.publishDate).toLocaleDateString()}
                        </h6>
                        <p className="card-text text-secondary">{post.excerpt}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </>
      )}
    </div>
  );
}

export default BlogList;